import { memo } from 'react'

import { Container } from './Styles'

interface SeparatorProps {
  type?: string
  size?: string | number
  innerRef?: any
  [key: string]: any
}

const Separator = ({ type, size, innerRef, ...props }: SeparatorProps) => {
  return <Container type={type} size={size} innerRef={innerRef} {...props} />
}

Separator.defaultProps = {
  type: 'vertical',
  size: '4vh',
  innerRef: undefined,
}

Separator.whyDidYouRender = true

export default memo(Separator)
